import React, { useState } from 'react';

import { Button } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  ModelBase 
} from "@models";
import { 
  Ammunition,
  Character,
  Creature,
  CreatureInstance,
  Item,
  Weapon,
} from "@dndModels";

// import API from "../../../utilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

import SelectObjectIndex from "@dndComponents/select/SelectObjectIndex";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import CharConnectUtilities from '@dndUtilities/char_connect_utilities';

interface Props {
  char: Character;
}

// const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const data_util = DataUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function CharacterSidekickCreatureInput({
  char
}: Props) {
  const [change_creature, setChangeCreature] = useState(false);
  const [filter, setFilter] = useState<any>({ challenge_rating: { "$lte": 0.5 } });

  const updateFilter = (changed: any = {}) => {
    const new_filter = {...changed};

    // TODO: Later I'll add a way to override this
    // if (!Object.keys(new_filter).includes("max_cr")) {
    //   new_filter.max_cr = 0.5;
    // } else if (new_filter.max_cr > 0.5) {
    //   new_filter.max_cr = 0.5;
    // }
    
    let challenge_rating = new_filter.challenge_rating;
    if (!challenge_rating) {
      challenge_rating = { "$lte": 0.5 };
    } else if (!challenge_rating["$lte"] || challenge_rating["$lte"] > 0.5) {
      challenge_rating["$lte"] = 0.5;
    }
    new_filter.challenge_rating = challenge_rating;

    setFilter(new_filter);
  }

  const addCreature = async (creature: ModelBase) => {
    if (creature instanceof Creature) {
      char.sidekick_creature_id = creature._id;
      char.sidekick_creature = creature;
      // console.log(character);
      // debugger;
      const ci = new CreatureInstance();
      await ci.copyCreature(creature, creature.challenge_rating, true);
      char.sidekick_ci = ci;
      char.base_ability_scores = ci.ability_scores.clone();
      for (const condition_id of ci.condition_immunities) {
        if (!char.condition_immunities.includes(condition_id)) {
          char.condition_immunities.push(condition_id);
        }
      }
      const finalize = () => {
        // onChange();
        char_util.repopulateCharFeatureBases(char);
        setChangeCreature(false);
      }

      const filter_weapons = [
        "Humanoid",
        // "Beast",
        // "Construct",
        "Aberration",
        "Undead",
        // "Dragon",
        // "Monstrosity",
        "Elemental",
        "Fey",
        "Giant",
        // "Ooze",
        // "Plant",
        "Shapechanger",
        "Celestial",
        "Fiend"].includes(creature.creature_type);
      if (filter_weapons) {
        const weapons = data_util.items.filter(o => o.item_type === "Weapon") as Weapon[];
        const add_us: Item[] = [];
        for (const fb of creature.action_fbs) {
          for (const feature of fb.features) {
            let weapon = weapons.find(o => feature.name.includes(o.name));
            if (weapon) {
              let item_id = weapon._id;
              if (char.items.filter(o => o.base_item_id === item_id).length === 0) {
                add_us.push(weapon);
              }
              if (weapon.ammunition_type !== "None") {
                const ammunition_type = weapon.ammunition_type;
                const ammo = data_util.items.find(o => o instanceof Ammunition && o.ammunition_type === ammunition_type);
                if (ammo) {
                  item_id = ammo._id;
                  if (char.items.filter(o => o.base_item_id === item_id).length === 0) {
                    add_us.push(ammo);
                  }
                }
              }
            } else {
              // Crossbows can slip through
              if (feature.name.includes("Crossbow")) {
                if (feature.name.includes("Heavy")) {
                  weapon = weapons.find(o => o.name.includes("Crossbow, Heavy"));
                  if (weapon) {
                    let item_id = weapon._id;
                    if (char.items.filter(o => o.base_item_id === item_id).length === 0) {
                      add_us.push(weapon);
                    }
                    const ammunition_type = weapon.ammunition_type;
                    const ammo = data_util.items.find(o => o instanceof Ammunition && o.ammunition_type === ammunition_type);
                    if (ammo) {
                      item_id = ammo._id;
                      if (char.items.filter(o => o.base_item_id === item_id).length === 0) {
                        add_us.push(ammo);
                      }
                    }
                  }
                } else if (feature.name.includes("Hand")) {
                  weapon = weapons.find(o => o.name.includes("Crossbow, Hand"));
                  if (weapon) {
                    let item_id = weapon._id;
                    if (char.items.filter(o => o.base_item_id === item_id).length === 0) {
                      add_us.push(weapon);
                    }
                    const ammunition_type = weapon.ammunition_type;
                    const ammo = data_util.items.find(o => o instanceof Ammunition && o.ammunition_type === ammunition_type);
                    if (ammo) {
                      item_id = ammo._id;
                      if (char.items.filter(o => o.base_item_id === item_id).length === 0) {
                        add_us.push(ammo);
                      }
                    }
                  }
                } else {
                  weapon = weapons.find(o => o.name.includes("Crossbow, Light"));
                  if (weapon) {
                    let item_id = weapon._id;
                    if (char.items.filter(o => o.base_item_id === item_id).length === 0) {
                      add_us.push(weapon);
                    }
                    const ammunition_type = weapon.ammunition_type;
                    const ammo = data_util.items.find(o => o instanceof Ammunition && o.ammunition_type === ammunition_type);
                    if (ammo) {
                      item_id = ammo._id;
                      if (char.items.filter(o => o.base_item_id === item_id).length === 0) {
                        add_us.push(ammo);
                      }
                    }
                  }
                }
              }
            }
          }
        }
        const addNext = () => {
          if (add_us.length === 0) {
            finalize();
          } else {
            const add_me = add_us.splice(0, 1)[0];
            if (add_me instanceof Ammunition) {
              connect_util.addItem({ char, item: add_me, count: 20 }).then(char_item => {
                // connect_util.equipItem(character, char_item);
                addNext();
              });
            } else {
              connect_util.addItem({ char, item: add_me }).then(char_item => {
                connect_util.equipItem(char, char_item);
                addNext();
              });
            }
          }
        }
        addNext();
      } else {
        finalize();
      }
    }
  }

  if (char.sidekick_creature_id === "" || change_creature) {
    return (
      <Grid container spacing={0} direction="row">
        { char.sidekick_creature_id !== "" && char.sidekick_creature && change_creature && 
          <Grid
            size={{
              xs: 12
            }}>
            { char.sidekick_creature.true_name } 
            <Button 
              fullWidth variant="contained" color="primary" 
              onClick={ () => {
                setChangeCreature(false);
              }}>
                Keep Creature
            </Button>
          </Grid>
        }
        <Grid
          size={{
            xs: 12
          }}>
          <SelectObjectIndex
            data_type="creature"
            character={char}
            filter={filter}
            updateFilter={updateFilter}
            sort={(obj1: ModelBase, obj2: ModelBase) => {
              if (obj1 instanceof Creature && obj2 instanceof Creature) {
                return obj1.challenge_rating > obj2.challenge_rating ? 1 : (obj1.challenge_rating === obj2.challenge_rating ? 0 : -1);
              }
              return 0;
            }}
            onClick={addCreature}
          />
        </Grid>
      </Grid>
    );
  } else if (char.sidekick_creature) {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="header"
          size={{
            xs: 6
          }}>
          { char.sidekick_creature.true_name }
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <Button 
            fullWidth variant="contained" color="primary" 
            onClick={ () => {
              setChangeCreature(true);
            }}>
              Change Creature
          </Button>
        </Grid>
        <DisplayStringWithReplacements display_string={ char.sidekick_creature.description } />
      </Grid>
    );
  } else return null;
}
